import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

import { AppContext } from 'context/AppContext';

const SocialConnect: React.FC = () => {
  const { authentication, refetchUserdetails } = useContext(AppContext);
  const { setAuthKey } = authentication;
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token');

    if (accessToken) {
      console.log('Social login success, setting auth key:', accessToken);
      setAuthKey(accessToken);
      setTimeout(async () => {
        await refetchUserdetails.refetch();
      }, 100);

      setTimeout(() => {
        // Check if there's a return URL stored from before social login
        const returnUrl = localStorage.getItem('social_login_return_url');
        localStorage.removeItem('social_login_return_url'); // Clean up
        
        if (returnUrl) {
          // Extract the path from the stored URL and navigate to it
          const url = new URL(returnUrl);
          navigate(url.pathname + url.search, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      }, 200);
    } else {
      console.log('No access token found, redirecting to home');
      navigate('/', { replace: true });
    }
  }, [setAuthKey, navigate, refetchUserdetails]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}>
      <Spin size="large" />
      <span style={{ marginTop: 16, fontSize: 16 }}>Processing login...</span>
    </div>
  );
};

export default SocialConnect;